import { SR_API_ACTION_GET_PET_BREED } from 'api/actionTypes';

export default async function getByName({ state, apiClient }, { name }) {
  if (state.get(['petBreeds', 'byName', name])) {
    return state.get(['petBreeds', 'byName', name]);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_PET_BREED,
    state: state,
    payload: {
      name,
    },
    onSuccess(petBreed) {
      state.set(['petBreeds', 'byName', name], petBreed);
    },
  });
}
